import React from 'react'

import {Box} from '@vio/atlas/helpers/Box'
import {SkeletonLoader} from '@vio/atlas/SkeletonLoader'

export const ReviewLoading = () => {
  return (
    <Box display="flex" flexDirection="column" gap="s600">
      <div>
        <SkeletonLoader width={89} />
        <SkeletonLoader width={183} />
      </div>
      <div>
        <SkeletonLoader width={298} />
        <SkeletonLoader width={488} />
      </div>
      <SkeletonLoader width={60} marginTop={0} />
    </Box>
  )
}
